// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getMantenimientos as listMantenimientosAPI,
    getMantenimiento as getMantenimientoAPI,
    addMantenimiento as addMantenimientoAPI,
    updateMantenimiento as updateMantenimientoAPI,
    deleteMantenimiento as deleteMantenimientoAPI
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { mantenimientosApiResponseError, mantenimientosApiResponseSuccess } from './actions';
import { MantenimientosActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getMantenimiento({ payload: { id } }) {
    try {
        const response = yield call(getMantenimientoAPI, id );
        const mantenimiento = response.data.data;
        // NOTE - You can change this according to response format from your api
        // api.setLoggedInUser(user);
        // setAuthorization(user['token']);
        yield put(mantenimientosApiResponseSuccess(MantenimientosActionTypes.GET_MANTENIMIENTO, mantenimiento));
    } catch (error) {
        yield put(mantenimientosApiResponseError(MantenimientosActionTypes.GET_MANTENIMIENTO, error));
        // api.setLoggedInUser(null);
        // setAuthorization(null);
    }
}

function* addMantenimiento({payload:mant}){
    try {
        const response = yield call(addMantenimientoAPI, {...mant});
        const mantenimiento = response.data.id;
        // NOTE - You can change this according to response format from your api
        // api.setLoggedInUser(user);
        // setAuthorization(user['token']);
        yield put(mantenimientosApiResponseSuccess(MantenimientosActionTypes.CREATE_MANTENIMIENTO, mantenimiento));
    } catch (error) {
        yield put(mantenimientosApiResponseError(MantenimientosActionTypes.CREATE_MANTENIMIENTO, error));
        // api.setLoggedInUser(null);
        // setAuthorization(null);
    }
}

function* updateMantenimiento({payload:mant}){
    try {
        const response = yield call(updateMantenimientoAPI, {...mant});
        const mantenimiento = response.data.id;
        // NOTE - You can change this according to response format from your api
        // api.setLoggedInUser(user);
        // setAuthorization(user['token']);
        yield put(mantenimientosApiResponseSuccess(MantenimientosActionTypes.UPDATE_MANTENIMIENTO, mantenimiento));
    } catch (error) {
        yield put(mantenimientosApiResponseError(MantenimientosActionTypes.UPDATE_MANTENIMIENTO, error));
        // api.setLoggedInUser(null);
        // setAuthorization(null);
    }
}
function* deleteMantenimiento({ payload: { id } }){
    try {
        const response = yield call(deleteMantenimientoAPI, id);
        const mantenimiento = response.data.id;
        // NOTE - You can change this according to response format from your api
        // api.setLoggedInUser(user);
        // setAuthorization(user['token']);
        yield put(mantenimientosApiResponseSuccess(MantenimientosActionTypes.DELETE_MANTENIMIENTO, mantenimiento));
    } catch (error) {
        yield put(mantenimientosApiResponseError(MantenimientosActionTypes.DELETE_MANTENIMIENTO, error));
        // api.setLoggedInUser(null);
        // setAuthorization(null);
    }
}



/**
 * List contactos
 */
// function* listMantenimientos({payload:{contactoId,dataIni,dataFi,productoId}}) {
function* listMantenimientos({payload:params}) {
    try {
        const response = yield call(listMantenimientosAPI,{...params});
        const listaMantenimientos = response.data.data;
        yield put(mantenimientosApiResponseSuccess(MantenimientosActionTypes.LIST_MANTENIMIENTOS, listaMantenimientos));
    } catch (error) {
        yield put(mantenimientosApiResponseError(MantenimientosActionTypes.LIST_MANTENIMIENTOS, error));
    }
}
// function* listInvoicesByClient({payload:{contactoId}}) {
//     try {
//         const response = yield call(getInvoicesByClientAPI,contactoId);
//         const listaInvoices = response.data.data;
//         yield put(mantenimientosApiResponseSuccess(MantenimientosActionTypes.LIST_INVOICES_BY_CLIENT, listaInvoices));
//     } catch (error) {
//         yield put(mantenimientosApiResponseError(MantenimientosActionTypes.LIST_INVOICES_BY_CLIENT, error));
//     }
// }


export function* watchGetMantenimiento(): any {
    yield takeEvery(MantenimientosActionTypes.GET_MANTENIMIENTO, getMantenimiento);
}

export function* watchListMantenimientos(): any {
    yield takeEvery(MantenimientosActionTypes.LIST_MANTENIMIENTOS, listMantenimientos);
}
// export function* watchListInvoicesByClient(): any {
//     yield takeEvery(MantenimientosActionTypes.LIST_INVOICES_BY_CLIENT, listInvoicesByClient);
// }
export function* watchCreateMantenimiento(): any{
    yield takeEvery(MantenimientosActionTypes.CREATE_MANTENIMIENTO,addMantenimiento);
}
export function* watchUpdateMantenimiento(): any{
    yield takeEvery(MantenimientosActionTypes.UPDATE_MANTENIMIENTO,updateMantenimiento);
}
export function* watchDeleteMantenimiento(): any{
    yield takeEvery(MantenimientosActionTypes.DELETE_MANTENIMIENTO,deleteMantenimiento)
}


function* mantenimientosSaga(): any {
    yield all([
        fork(watchGetMantenimiento),
        fork(watchListMantenimientos),
        // fork(watchListInvoicesByClient),
        fork(watchCreateMantenimiento),
        fork(watchUpdateMantenimiento),
        fork(watchDeleteMantenimiento),
    ]);
}

export default mantenimientosSaga;
